// extracted by mini-css-extract-plugin
module.exports = {"wbpa5cz":"wbpa5cz"};